import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import "./ProjectSubmission.css";

import { useLocation, useNavigate } from 'react-router-dom';

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import FileUploadButton from '../../Components/FileManager/FileUploadButton';
import PDFViewButton from '../../Components/FileManager/PDFViewButton';

function ProjectSubmission(props) {
    const [form, setForm] = useState({});
    const [group, setGroup] = useState([]);
    const [user, setUser] = useState({});
    const [files, setFiles] = useState({});
    const [formMessage, setFormMessage] = useState("");
    const [isCompleted, setIsCompleted] = useState(false);

    const { state } = useLocation();
    const navigate = useNavigate();

    const filesLoaded = (file, type) => {
      if (type === "final_document") {
        setFiles((prev) => ({...prev, document: {...file}}));
      }
      else if (type === "final_presentation") {
        setFiles((prev) => ({...prev, presentation: {...file}}));
      }
      else if (type === "photo") {
        setUser((prev) => ({...prev, photo: file.filepath}));
      }
    }

    async function submitForm(event) {
        event.preventDefault();
        if (files.document === undefined || files.presentation === undefined){
          setFormMessage('You must upload your Final Document and a Final Presentation.');
          return;
        }

        let updatedForm = form;
        updatedForm.questions[0].response = ["completed"];
        if (state.assignment.is_completed) {
            await axios.put(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/responses`, 
                {
                    assigment: updatedForm
                },
                { headers: {Authorization: `Bearer ${state.token.access_token}`}}
            );
        } else {
            await axios.post(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/responses`, 
                {
                    assigment: updatedForm
                },
                { headers: {Authorization: `Bearer ${state.token.access_token}`}}
            );
            state.assignment.is_completed = true;
        }
        await axios.put(`${process.env.REACT_APP_API_HOST}/api/projects/submit`, 
          {},
          { headers: {Authorization: `Bearer ${state.token.access_token}`}}
        );
        setFormMessage("Assignment has been submitted");
        navigate("/student");
    }

    useEffect(() => {
        async function loadForm() {
            const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/${state.assignment.assignment_id}/response`,
                { headers: { Authorization: `Bearer ${state.token.access_token}`} }
            )
            let formData = response.data;
            let start = moment.utc(formData.start, moment.ISO_8601, true);
            let end = moment.utc(formData.end, moment.ISO_8601, true);
            formData.start = start.local().format("dddd, MMMM Do YYYY, h:mm a");
            formData.end = end.local().format("dddd, MMMM Do YYYY, h:mm a");
            setForm(formData);
            setIsCompleted(state.assignment.is_completed);
        }

        async function loadGroup() {
            const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/groups/findGroup`,
                { headers: { Authorization: `Bearer ${state.token.access_token}`} }
            )
            setGroup(response.data);
            setUser(response.data.members.find((user) => user.user_id === response.data.user));
            setFiles({
              document: response.data.files.find((file) => file.type === "final_document"),
              presentation: response.data.files.find((file) => file.type === "final_presentation"),
            });
        }

        loadForm();
        loadGroup()
    }, [])
    

    return (
      <>
        <DashboardNavbar />
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", paddingInline: "10%"}}>
            <h2 className="title">{form.name}</h2>
            <div>
                <p>{"Start: " + form.start}</p>
                <p>{"End: " + form.end}</p>
            </div>
        </div>
        <form className="project-submission" onSubmit={submitForm}>
          <section>
            <p style={{fontSize: "24px"}}>{group.project?.name}</p>
            <p><b>Sponsor</b>: {group.project?.sponsor}</p>
            <p><b>Members</b>: {group.members?.map((user) => user.first_name + " " + user.last_name).join(", ")}</p>
            <p><b>Description</b>: {group.project?.description}</p>            
          </section>
          <section>
            <h4>
              Public Photo (Optional):
              <p className='alt-text'>Note: This will be displayed publicly alongside your project</p>
            </h4>
            {user.photo && 
              <PDFViewButton 
                file={{ filepath: user.photo, filename: "Public Photo" }}
              />
            }
            <FileUploadButton
              type={"photo"}
              // selectedClass={}
              host={process.env.REACT_APP_API_HOST}
              singleMultiple={"multiple"}
              associatedGroupingType={"project"}
              token={state.token}
              group={group}
              filesLoaded={filesLoaded}
            />
          </section>
          <section>
            <h4>
              Project Files
              <p className='alt-text'>Note: Only one person from your group needs to submit these files</p>
            </h4>
            <p>Final Project Documentation (PDF):</p>
            {files.document && 
              <PDFViewButton 
                file={{ filepath: files.document.filepath, filename: "Submitted Final Document" }}
              />
            }
            <FileUploadButton
              type={"final_document"}
              host={process.env.REACT_APP_API_HOST}
              singleMultiple={"multiple"}
              associatedGroupingType={"project"}
              token={state.token}
              group={group}
              filesLoaded={filesLoaded}
            />
            <br />
            <p>Project Presentation (PDF/PPTX):</p>
            {files.presentation && 
              <PDFViewButton 
                file={{ filepath: files.presentation.filepath, filename: "Submitted Final Presentation" }}
              />
            }
            <FileUploadButton
              type={"final_presentation"}
              host={process.env.REACT_APP_API_HOST}
              singleMultiple={"multiple"}
              associatedGroupingType={"project"}
              token={state.token}
              group={group}
              filesLoaded={filesLoaded}
            />
          </section>
          <div className="footer">
            <div>
                <p>{formMessage}</p>
                <button type="submit">{isCompleted ? "Resubmit Project" : "Submit Project"}</button>
            </div>
          </div>
        </form>
      </>
    );
}

export default ProjectSubmission;